import { useNavigate } from 'react-router-dom'
import { formatPhoneNumber } from 'react-phone-number-input'
import moment from 'moment'
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { Icon, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { PracticeProfileEntry } from './PracticeProfileEntry'
import { getCurrentUser } from '@/selectors/user.selectors'

export const PersonalInformationSection = () => {
  const navigate = useNavigate()
  const user = useReselector(getCurrentUser)

  return (
    <div className="personal-information-section">
      <div className="header mb-6">
        <div className="flex flex-row gap-2 items-center">
          <Icon
            icon={solid('user')}
            backgroundStyle="rounded"
            backgroundColor="emphasis"
            size="sm"
          />
          <Text variant={TypographyStyles.LABEL_MD} className="mb-2">
            Personal Information
          </Text>
        </div>
        <Icon
          icon={regular('pen-to-square')}
          onClick={() => navigate('/practice/profile/editPersonal')}
        />
      </div>

      <div>
        <PracticeProfileEntry label="First Name" value={user?.firstName} />
        <PracticeProfileEntry label="Last Name" value={user?.lastName} />
        <PracticeProfileEntry
          label="Date of Birth"
          value={
            user?.dateOfBirth &&
            moment.utc(user?.dateOfBirth).format(DATE_FORMATS.DISPLAY_LONG)
          }
        />
        <PracticeProfileEntry
          label="Personal Email"
          value={user?.personalEmail}
        />
        <PracticeProfileEntry
          label="Personal Phone"
          value={user?.personalPhone && formatPhoneNumber(user?.personalPhone)}
        />
        <PracticeProfileEntry
          label="Personal Address"
          value={user?.homeAddress}
        />
      </div>
    </div>
  )
}
